export default () => {
  return {
    errors: [],
    workspacesList: [],
    newWorkspaceId: '',
    isLoading: false
  }
}
